import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { LoadablePaint } from '@confluence/loadable';
import { getIsNav4Enabled } from '@confluence/nav4-enabled';

const SpaceSettingsRelatedPagesRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsRelatedPagesRouteComponent" */ './SpaceSettingsRelatedPagesRouteComponent'
			)
		).SpaceSettingsRelatedPagesRouteComponent,
});

export const SpaceSettingsRelatedPagesRoute = ({ params: { spaceKey } }) => (
	<SpaceSettingsRelatedPagesRouteComponent spaceKey={spaceKey} />
);

SpaceSettingsRelatedPagesRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }) => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsRelatedPages', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: getIsNav4Enabled() ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
